import React, { useEffect, useState } from "react";
import DashPanel from "../../molecules/DashPanel";
import { Table, TableBody, TableFooter, TableHead, TableRow, TableCell } from "@mui/material";

import Pagination from "@mui/material/Pagination";
import {
  SearchResult,
  OrderedItemSearchOption,
  CommonUtil as cu,
  OrderedItem,
} from "../../../types/elements";
import { gqladm } from "../../../graphql/gqladm";
import ItemCard from "../../molecules/ItemCard";

const PanelOrderedItems: React.FC = (props) => {
  const [sopt, setSopt] = useState<OrderedItemSearchOption>({
    limit: 10,
    offset: 0,
    orderby: "created_desc",
  });
  const [result, setResult] = useState<SearchResult<OrderedItem>>({});

  const load = (opt: OrderedItemSearchOption) => {
    gqladm
      .searchOrderedItems({ ...sopt, ...opt })
      .then((result) => {
        console.log("result");
        setResult(result);
        setSopt({ ...sopt, offset: result.offset ? result.offset : sopt.offset });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleChangePage = (page: number) => {
    console.log("handleChangePage", page);
    const offset = (page - 1) * (sopt.limit ? sopt.limit : 10);
    if (offset !== sopt.offset) {
      load({ ...sopt, offset: offset });
    }
  };

  useEffect(() => {
    load(sopt);
  }, []);
  return (
    <DashPanel title="최근 출고내역" actions={<div></div>}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>주문ID</TableCell>
            <TableCell>상품</TableCell>
            <TableCell>옵션</TableCell>
            <TableCell>수량</TableCell>
            <TableCell>출고일자</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {result.list?.map((o, idx) => {
            return (
              <TableRow key={idx}>
                <TableCell>{o.id}</TableCell>
                <TableCell>{o.orderId}</TableCell>
                <TableCell>
                  {o?.itemStock?.itemOption?.item && (
                    <ItemCard type="mini" item={o.itemStock.itemOption.item} />
                  )}
                </TableCell>
                <TableCell>{o?.itemStock?.itemOption?.name}</TableCell>
                <TableCell>{o?.orderedCount}</TableCell>
                <TableCell>{o.created && cu.getFormattedDate(o.created, "MM/dd HH:mm")}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TableCell colSpan={6}>
              <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                <Pagination
                  onChange={(e, p) => handleChangePage(p)}
                  count={Math.ceil(
                    (result.total ? result.total : 0) / (result?.limit ? result.limit : 10)
                  )}
                  page={
                    Math.ceil(
                      (result?.offset ? result.offset : 0) / (result?.limit ? result.limit : 10)
                    ) + 1
                  }
                />
              </div>
            </TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    </DashPanel>
  );
};

export default PanelOrderedItems;
